require('./bootstrap');
const tinymce = require("tinymce");

//GLOBALS

let tinySettings = {
    selector: '.richText',
    height: 300,
    width: '100%',
    plugins: 'code link image',
    content_css: '/css/app.css',
    forced_root_block: false,
    entity_encoding: 'raw',
    relative_urls: false,
    remove_script_host: false,
    trapFocus: false,
    link_class_list: [
        {title: 'None', value: ''},
        {title: 'Button', value: 'btn btn-save'},
    ]
};

tinymce.init(tinySettings);

$('.deleteButton').click(function (event) {
    event.preventDefault();
    if (confirm($('#jsQuestionReally').val())) {
        $(this).parent().submit();
    }
});

$('.clickAbleRow').click(function () {
    window.location = $(this).data('href');
});

// NEWSARTICLE

$('#newsArticleSaveButton').click(function (event) {
    $('#newsArticleForm').submit();
});

// CONTACT

$('#contactSaveButton').click(function (event) {
    $('#contactForm').submit();
});

// NOTIFICATION

$('#notificationSaveButton').click(function (event) {
    $('#notificationForm').submit();
});

// USERS

$('#userSaveButton').click(function (event) {
    $('#userForm').submit();
});

// FILES

$('.copyUrl').click(function () {
    let url = $(this).data('url');
    let temp = $('<input>');
    $('body').append(temp);
    temp.val(url).select();
    document.execCommand('copy');
    temp.remove();
});

// PRODUCTS

$('#productSaveButton').click(function (event) {
    $('#productForm').submit();
});

window.sortable = require("jquery-ui"), require('jquery-ui/ui/widgets/sortable'), require('jquery-ui/ui/disable-selection'), require('jquery-ui/ui/widgets/accordion');

$('#subProductAccordion').sortable();
$('.productSort').sortable();

$('#addSubProduct').click(function (event) {
    event.preventDefault();
    let newIndex = parseInt($('#newSubProductIndex').val());
    let html = $('#subProductTemplate').html();
    html = html.replace(/###loopIteration###/g, newIndex);
    $('#subProductAccordion .collapse').collapse('hide');
    $('#subProductAccordion').append(html);
    $('#newSubProductIndex').val(newIndex + 1);
    initNewTinyMce(newIndex);
    initNewDeleteButton(newIndex);
});

$('.removeSubProduct').click(function (event) {
    event.preventDefault();
    if (confirm($('#jsQuestionReally').val())) {
        $('#subProductNo' + $(this).data('loop')).remove();
    }
});

$('#addProductFile').click(function (event) {
    event.preventDefault();
    let newIndex = parseInt($('#newFileIndex').val());
    let html = $('#fileTemplate').html();
    html = html.replace(/###loopIteration###/g, newIndex);
    $('#fileContainer').append(html);
    $('#newFileIndex').val(newIndex + 1);
    initNewFileDeleteButton(newIndex);
});

$('.removeProductFile').click(function (event) {
    event.preventDefault();
    if (confirm($('#jsQuestionReally').val())) {
        $('#fileRow' + $(this).data('loop')).remove();
    }
});

function initNewTinyMce(index) {
    tinymce.init({
        selector: '.richText' + index,
        height: 200,
        width: '100%',
        plugins: 'code link image',
        content_css: '/css/app.css',
        forced_root_block: false,
        entity_encoding: 'raw',
        relative_urls: false,
        remove_script_host: false,
        link_class_list: [
            {title: 'None', value: ''},
            {title: 'Button', value: 'btn btn-save'},
        ]
    });
}

function initNewDeleteButton(index) {
    $('.removeSubProduct' + index).click(function (event) {
        event.preventDefault();
        if (confirm($('#jsQuestionReally').val())) {
            $('#subProductNo' + $(this).data('loop')).remove();
        }
    });
}

function initNewFileDeleteButton(index) {
    $('.removeProductFile' + index).click(function (event) {
        event.preventDefault();
        $('#fileRow' + index).remove();
    });
}

$(document).on('focusin', function(e) {
    if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
        e.stopImmediatePropagation();
    }
});

